import {URL} from '@netx/core-next/url';
import {getAuthorizationHeader} from '@netx/core-auth-next/utils/getAuthorizationHeader';
import {AwsS3MultipartOptions as IAwsS3MultipartOptions} from '../../lib/multi-destination';

export type AwsS3MultipartOptions = Partial<IAwsS3MultipartOptions>;

export const createS3MultipartOptions = (options?: AwsS3MultipartOptions) => {
	const s3MultipartOptions: IAwsS3MultipartOptions = {
		companionUrl: URL.uploads3Endpoint,
		...options,
		companionHeaders: {
			...getAuthorizationHeader(),
			...options?.companionHeaders,
		},
	};
	return s3MultipartOptions;
};

export default createS3MultipartOptions;
